import getClientApiRequestTransformer from '@/api/transformers/auth.request.transformer';
import getSocketIdRequestTransformer from '@/api/transformers/socketId.request.transformer';
import apiClient from '@/apiClient';
import Transaction from '@/models/transaction';
import {AxiosResponse} from 'axios';
import getStorehouseTransformer from './transformers/storehouse/storehouseTransformer';
import getStorehouseProductTransformer from './transformers/storehouse/storehouseProductTransformer';
import StorehouseProduct from '@/models/storehouseProduct';

export default {
  async fetchStorehouse() {
    return apiClient.get('/storehouse/list', {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
      transformResponse: getStorehouseTransformer()
    })
      .then(({data}: AxiosResponse) => data);
  },
  async completeSharedTransaction(transaction: Transaction) {
    return apiClient.post('/storehouse/transaction/complete/shared', {
      transactionId: transaction.id
    }, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async completeRequestTransaction(transaction: Transaction) {
    return apiClient.post('/storehouse/transaction/complete/request', {
      transactionId: transaction.id
    }, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async cancelTransaction(transaction: Transaction) {
    return apiClient.delete(`/storehouse/transaction/cancel/${transaction.id}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async removeIngredient(ingredientId: string) {
    return apiClient.delete(`/storehouse/ingredient/remove/${ingredientId}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    })
      .then(({data}: AxiosResponse) => data);
  },
  async removeProduct(productId: string) {
    return apiClient.delete(`/storehouse/product/remove/${productId}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    })
      .then(({data}: AxiosResponse) => data);
  },
  async createSharedTransaction(storehouse: any, payload: any) {
    return apiClient.post(`/storehouse/transaction/shared/${storehouse.id}`, payload, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    })
      .then(({data}: AxiosResponse) => data);
  },
  async createRequestTransaction(storehouse: any, payload: any) {
    return apiClient.post(`/storehouse/transaction/request/${storehouse.id}`, payload, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    })
      .then(({data}: AxiosResponse) => data);
  },
  async createWriteOffTransaction(storehouse: any, payload: any) {
    return apiClient.post(`/storehouse/transaction/write-off/${storehouse.id}`, payload, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    })
      .then(({data}: AxiosResponse) => data);
  },
  async createInsertionTransaction(storehouse: any, payload: any) {
    return apiClient.post(`/storehouse/transaction/insertion/${storehouse.id}`, payload, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    })
      .then(({data}: AxiosResponse) => data);
  },
  async editProductRemainder({id, ...editedFields}: any): Promise<any> {
    return apiClient.patch(`/storehouse/product/edit/${id}`, editedFields, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async editIngredientRemainder({id, ...editedFields}: any): Promise<any> {
    return apiClient.patch(`/storehouse/ingredient/edit/${id}`, editedFields, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async editProduct({id, editedFields}: any): Promise<any> {
    return window.axios.patch(`/storehouse/menu/product/edit/${id}`, editedFields, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async editIngredient({id, editedFields}: any): Promise<any> {
    return window.axios.patch(`/storehouse/menu/ingredient/edit/${id}`, editedFields, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async fetchContractorsByName(name: string) {
    return apiClient.get('/storehouse/contractor/list', {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
      params: {
        name
      }
    })
      .then(({data}: AxiosResponse) => data);
  },
  async getStorehouseProductByProjectProductId(projectProductId: string): Promise<StorehouseProduct> {
    return apiClient.get(
      `/storehouse/product/details/${projectProductId}`,
      {
        transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
        transformResponse: getStorehouseProductTransformer(),
      }
    )
      .then(({data}: AxiosResponse) => data);
  }
};
